<template>
  <div class="employee-assign">
    <header class="page-header">
      <button class="back" @click="$router.back()"><van-icon name="arrow-left"/></button>
      <div class="page-title">分配角色</div>
      <button class="save-btn" @click="save">保存</button>
    </header>

    <main class="content">
      <section v-if="loading" class="loading"><van-loading/></section>

      <section v-else class="emp-info">
        <div class="avatar">{{ employee.name ? employee.name.slice(-1) : '?' }}</div>
        <div class="info">
          <b>{{ employee.name }}</b>
          <small>{{ employee.departmentName || '—' }} · {{ employee.positionName || '—' }}</small>
        </div>
      </section>

      <section v-else class="role-picker">
        <div class="section-title">可分配角色</div>
        <div class="role-options">
          <label v-for="role in allRoles" :key="role.id" class="role-option">
            <input type="checkbox" :value="role.id" v-model="selectedRoleIds"/>
            <span class="opt-body">
              <b>{{ role.name }}</b>
              <small>{{ role.code }} · {{ scopeLabel(role.dataScope) }}</small>
            </span>
          </label>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import identityApi from '@/api/identity';

export default {
  name: 'BossEmployeeRoleAssign',
  data() {
    return {
      employeeId: null,
      employee: {},
      allRoles: [],
      selectedRoleIds: [],
      loading: true
    };
  },
  async created() {
    this.employeeId = Number(this.$route.params.id);
    this.load();
  },
  methods: {
    scopeLabel(s) {
      return {
        TENANT: '全公司',
        DEPARTMENT: '本部门',
        DEPARTMENT_AND_CHILDREN: '部门及下级',
        SELF: '仅自己'
      }[s] || s;
    },
    async load() {
      this.loading = true;
      try {
        const [roles, current] = await Promise.all([
          identityApi.listRoles(),
          identityApi.rolesForEmployee(this.employeeId)
        ]);
        this.allRoles = roles;
        this.selectedRoleIds = (current || []).map(r => r.id);
        // employee 基本信息从 rolesForEmployee 响应里取，或调 getEmployee
        try {
          const emp = await identityApi.getEmployee(this.employeeId);
          this.employee = emp || {};
        } catch (_) { this.employee = {}; }
      } catch (e) {
        this.$toast.fail(e.message || '加载失败');
      } finally {
        this.loading = false;
      }
    },
    async save() {
      try {
        // 先 unassign 再 assign（简单策略）
        const currentIds = this.selectedRoleIds.slice();
        const prev = this.allRoles.filter(r => !currentIds.includes(r.id)).map(r => r.id);
        // 为了安全，直接按当前选中列表逐个 assign，不处理 unassign（后端 assignRole 是幂等）
        for (const rid of currentIds) {
          try { await identityApi.assignRole(this.employeeId, rid); } catch (_) {}
        }
        for (const rid of prev) {
          try { await identityApi.unassignRole(this.employeeId, rid); } catch (_) {}
        }
        this.$toast.success('保存成功');
        this.$router.back();
      } catch (e) {
        this.$toast.fail(e.message || '保存失败');
      }
    }
  }
};
</script>

<style scoped>
.page-header {
  position: sticky; top: 0; z-index: 10;
  height: 44px; background: #fff;
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 12px; border-bottom: 1px solid #eee;
}
.back, .save-btn { background: none; border: 0; font-size: 14px; }
.save-btn { color: #1989fa; font-weight: 500; }
.page-title { font-weight: 500; }
.content { padding: 12px 12px calc(66px + env(safe-area-inset-bottom)); }
.emp-info {
  display: flex; gap: 12px; align-items: center;
  background: #fff; border-radius: 10px; padding: 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,.04);
}
.avatar {
  width: 44px; height: 44px; border-radius: 50%;
  background: #1989fa; color: #fff; font-size: 18px;
  display: flex; align-items: center; justify-content: center;
}
.info b { display: block; font-size: 16px; }
.info small { color: #999; font-size: 12px; }
.role-picker { margin-top: 12px; }
.section-title { color: #666; font-size: 13px; padding: 4px 2px 8px; }
.role-options { display: flex; flex-direction: column; gap: 8px; }
.role-option {
  display: flex; gap: 10px; align-items: center;
  background: #fff; border-radius: 10px; padding: 12px 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
}
.role-option input { accent-color: #1989fa; transform: scale(1.2); }
.opt-body b { display: block; font-size: 15px; }
.opt-body small { color: #999; font-size: 12px; }
.loading { padding: 40px 0; text-align: center; }
</style>



// WEBPACK FOOTER //
// src/views/boss/identity/EmployeeAssign.vue